module.exports = __webpack_public_path__ + "static/media/speaker-icon.c24df0aa.png";